<template>
  <div>
    <div class="container pt-0" v-if="success !== null">
      <div class="row">
        <div v-if="isClinius" class="col" :class="{ 'text-center': isClinius }">
          <h1 :class="{ 'fs-40': isClinius }">{{ $t("heading_booking") }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="pane">
            <div class="row">
              <div
                v-if="proposal"
                class="col-md-5 pr-lg-5 text-left"
                :class="{ 'border-right': !isMobile }"
              >
                <h2>{{ $t("your_appointment") }}</h2>
                <termin-zusammenfassung />
              </div>
              <div class="col">
                <div class="text-center">
                  <div
                    class="fs-40 mt-5"
                    :class="{ 'text-primary': isClinius }"
                  >
                    <font-awesome-icon v-if="success" icon="check" />
                    <font-awesome-icon v-if="!success" icon="times" />
                  </div>
                  <div
                    class="text-confirm-head mt-3"
                    :class="{ 'text-primary': isClinius }"
                  >
                    {{
                      this.success
                        ? $t("appointment_canceled")
                        : $t("termin_nicht_abgesagt")
                    }}
                  </div>
                  <div v-if="!success" class="row mt-5">
                    <div class="col-md-8 offset-md-2">
                      <p
                        class="text-confirm text-center"
                        v-html="$t('error.terminbestaetigung_fehler')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Start from "@/components/Start.vue";

import TerminZusammenfassung from "@/components/TerminZusammenfassung";

export default {
  name: "TerminbestaetigungComponent",
  components: {
    TerminZusammenfassung,
  },
  data() {
    return {
      token: this.$route.query.cancel,
      success: null,
    };
  },
  async created() {
    if(this.token)
      this.success = await this.$store.dispatch("cancelTermin", [this.token]);
    else
      this.success = true
  },
  computed: {
    proposal() {
      return this.$store.state.termin.selectedTermin;
    },
    terminart() {
      return this.$store.state.termin.behandlung;
    },
    praxis() {
      if (typeof this.$store.state.termin.praxis === "string")
        return this.$store.state.praxen.find(
          (p) => p.value === this.$store.state.termin.praxis
        );
      else return this.$store.state.termin.praxis;
    },
  },
  methods: {

  },
};
</script>
